import { render } from "./WordRankCell.vue?vue&type=template&id=4437fdc4&scoped=true"
import script from "./WordRankCell.vue?vue&type=script&lang=js"
export * from "./WordRankCell.vue?vue&type=script&lang=js"

import "./WordRankCell.vue?vue&type=style&index=0&id=4437fdc4&scoped=true&lang=scss"

import exportComponent from "/opt/jenkins/workspace/asoworld-uatnf9mf/asoworld-wap-frontend/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4437fdc4"]])

export default __exports__